import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Lock, ArrowLeft } from "lucide-react";
import { api, errText } from "../lib/api";
import { LogoMark } from "../components/Logo";
import { Dashboard } from "../components/admin/Dashboard";
import { SetPassword } from "../components/admin/SetPassword";

const LoginForm = ({ onLogin, onSetPassword, initialEmail = "" }) => {
  const [email, setEmail] = useState(initialEmail);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      onLogin(data);
    } catch (err) {
      setError(err?.response?.status === 401 ? "Λάθος email ή κωδικός." : errText(err, "Σφάλμα σύνδεσης."));
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="grid min-h-screen place-items-center px-5">
      <form onSubmit={submit} className="glass w-full max-w-md rounded-[26px] p-8 sm:p-10" data-testid="admin-login-form">
        <LogoMark className="h-12 w-12" />
        <p className="eyebrow mt-8">KORANI GROUP</p>
        <h1 className="mt-2 font-display text-3xl font-black uppercase text-white">Διαχείριση</h1>
        <p className="mt-2 flex items-center gap-2 text-sm text-zinc-400"><Lock className="h-4 w-4" />Ιδιωτική πρόσβαση</p>
        <div className="mt-8 space-y-4">
          <input className="input" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" data-testid="admin-email-input" />
          <input className="input" type="password" placeholder="Κωδικός" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" data-testid="admin-password-input" />
        </div>
        {error && <p className="mt-4 text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={loading} className="btn-primary btn-lg mt-6 w-full justify-center" data-testid="admin-login-btn">
          {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Σύνδεση"}
        </button>
        <button type="button" onClick={onSetPassword} className="mt-4 w-full text-sm text-[#00E676] hover:underline" data-testid="admin-set-password-link">Ορισμός ή επαναφορά κωδικού</button>
        <Link to="/" className="mt-6 flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-zinc-400 hover:text-white" data-testid="admin-back-link"><ArrowLeft className="h-4 w-4" />Αρχική</Link>
      </form>
    </div>
  );
};

export default function Admin() {
  const [user, setUser] = useState(null);
  const [setting, setSetting] = useState(false);
  const [lastEmail, setLastEmail] = useState("");
  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() =>
      api.post("/auth/refresh").then(() => api.get("/auth/me")).then((r) => setUser(r.data)).catch(() => setUser(false)));
  }, []);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };
  return (
    <div className="min-h-screen bg-[#050706] text-white">
      {user === null && <div className="grid min-h-screen place-items-center"><Loader2 className="h-8 w-8 animate-spin text-[#00E676]" /></div>}
      {user === false && (setting
        ? <div className="grid min-h-screen place-items-center px-5"><SetPassword onDone={(em) => { if (em) setLastEmail(em); setSetting(false); }} /></div>
        : <LoginForm onLogin={setUser} onSetPassword={() => setSetting(true)} initialEmail={lastEmail} />)}
      {user && <Dashboard user={user} onLogout={logout} />}
    </div>
  );
}
